[
  {
    "code": "ZM-02",
    "name": "Central"
  },
  {
    "code": "ZM-08",
    "name": "Copperbelt"
  },
  {
    "code": "ZM-03",
    "name": "Eastern"
  },
  {
    "code": "ZM-04",
    "name": "Luapula"
  },
  {
    "code": "ZM-09",
    "name": "Lusaka"
  },
  {
    "code": "ZM-06",
    "name": "North-Western"
  },
  {
    "code": "ZM-05",
    "name": "Northern"
  },
  {
    "code": "ZM-07",
    "name": "Southern"
  },
  {
    "code": "ZM-01",
    "name": "Western"
  }
]